import config from "../.config.json";

const DEBUG = config.debug;
const NODE_ENV = config.nodeEnv;
const LOCAL_DEV = config.localDev;
const PRODUCTION = config.production === "TRUE";

let frontUrl, backUrl, ipLocalLan = '192.168.101.20'

if (PRODUCTION && LOCAL_DEV === "HOME") {
  frontUrl = `http://${ipLocalLan}:3000`
  backUrl = `http://${ipLocalLan}:3001`
} else if (PRODUCTION && LOCAL_DEV === "SEAP" && NODE_ENV === 'DEVELOPER') {
  frontUrl = "http://10.34.7.2:3000"
  backUrl = "http://10.34.7.2:3001"
} else if (PRODUCTION && LOCAL_DEV === "SEAP" && NODE_ENV === 'PRODUCTION') {
  frontUrl = "https://e-pu.seap.ma.gov.br"
  backUrl = "https://api.e-pu.seap.ma.gov.br"
} else {
  frontUrl = "http://localhost:3000"  // Mudança: 0.0.0.0 → localhost
  backUrl = "http://localhost:3001"   // Mudança: 0.0.0.0 → localhost
}

export const baseURL = frontUrl;
export const FRONT_URL = frontUrl;
export const API_URL = backUrl;
export const AUTH_URL = DEBUG ? 'http://localhost:3001' : API_URL;
export const WHATS_URL = DEBUG ? 'http://localhost:3010' : API_URL;
export const SOCKET_URL = DEBUG ? 'ws://localhost:3015' : API_URL;
export const API_VELTI_URL = 'https://api.monitor.seap.ma.gov.br';

const version = require('../../package.json').version

// console.log(">>> ", PRODUCTION && LOCAL_DEV === "SEAP" && NODE_ENV === 'PRODUCTION')

// if (DEBUG || NODE_ENV !== 'PRODUCTION') {
console.log('>>> ',
  version,
  baseURL,
  FRONT_URL,
  API_URL,
  API_VELTI_URL,
  NODE_ENV,
  LOCAL_DEV,
  PRODUCTION,
  DEBUG,
);
// }
